// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l7tJrmqzWoj4VwMEk5qd{width:100%}`, "",{"version":3,"sources":["webpack://./src/Components/Atoms/Skeleton/SkeletonTimelineDetail/SkeletonTimelineDetail.module.scss"],"names":[],"mappings":"AAAA,sBACI,UAAA","sourcesContent":[".Container {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `l7tJrmqzWoj4VwMEk5qd`
};
export default ___CSS_LOADER_EXPORT___;
